import { Typography } from "@circle-react-uikit/Typography";
import type { Plan } from "@circle-react/types";

import { t } from "@/i18n-js/instance";

import { SubmitButton } from "../../../RegularPlan/SubmitButton";

interface CollapsedCheckoutViewProps {
  onExpand: () => void;
  selectedPlan: Plan;
}

export const CollapsedCheckoutView = ({
  onExpand,
  selectedPlan,
}: CollapsedCheckoutViewProps) => (
  <div className="flex flex-col gap-y-4">
    <div className="flex justify-between">
      <button type="button" onClick={onExpand}>
        <Typography.LabelXs color="text-default" textTransform="underline">
          {t(
            "pricing_plans.plan_settings.mobile_checkout_overlay.view_summary",
          )}
        </Typography.LabelXs>
      </button>
      <Typography.LabelXs weight="semibold">
        {selectedPlan.annual_base_amount_with_currency}
      </Typography.LabelXs>
    </div>

    <SubmitButton plan={selectedPlan} />
  </div>
);
